import React from 'react'
import CategoryItem from './category-item'

class CategoriesList extends React.Component {
  render() {
    const {allData, activeCategory, handleClick} = this.props;
    const sortedCategories = allData.sort(function(a, b) {
      return a.node.orderNumber - b.node.orderNumber
    })

    return (
      <div className="categories-list">
        {sortedCategories.map((cat, i) => {
          return (
            <CategoryItem
              key={i}
              cat={cat}
              handleClick={handleClick}
              activeCategory={activeCategory} />
          );
        })}
      </div>
    )
  }
}

export default CategoriesList



// WEBPACK FOOTER //
// ./src/components/categories-list.js